import React from 'react'
import NavigationSection from "../../../core/model2/navigation/navigation-section"
import {NavigationButtonPosition} from "../../../core/model2/navigation/@const"
import {ReorderItemProps} from "../../../core/gd-ui/sortable-list-4/@types"
import Navigation_ButtonHint from "../components/hint/hint-section";
import Navigation_BaseButton from "./base-button";
import openChat from "../actions/open-chat";
import Workspace from "../../../core/model2/space/workspaces/workspace";
import PopoverMenu from "../../../core/gd-components/popover-menu/popover-menu/popover-menu";
import Navigation_ButtonHintSpace from "../components/hint/hint-space";
import {featureAccess} from "../../../core/gd/access-control/feature-access/feature-access";
import {Feature} from "../../../core/gd/access-control/feature-access/const";

type Props = {
    className?          : string,
    // section             : NavigationSection,
    onClickCallback?    : callback
    inMorePopover       : boolean
} & ReorderItemProps

// const debug = "Navigation_ButtonChats"
const debug = false

export default class Navigation_ButtonChats extends React.Component<Props,any> {

    public refHint                  : React.RefObject<Navigation_ButtonHintSpace> = React.createRef<Navigation_ButtonHintSpace>()

    constructor(props:Props) {
        super(props);

        this.state = {
            newMessagesCount: gd.session.counters.getChatNewMessagesCount(),
        };
    }

    componentDidMount() {
        gd.session.counters.on('change:chatNewMessages',this.onCounterChanged);
    }

    componentWillUnmount() {
        gd.session.counters.off('change:chatNewMessages',this.onCounterChanged);
    }

    onCounterChanged = () => {
        this.setState({
            newMessagesCount: gd.session.counters.getChatNewMessagesCount()
        })
    }

    showContextMenu = (e: React.MouseEvent) => {
        e.stopPropagation()
        e.preventDefault()

        const options : Option[] = gd.spaces.chats.contextMenuOptions

        if (_.size(options) < 1) {
            return null
        }

        debug && console.log(debug, 'showContextMenu', e)

        gd.layout.contextMenu.show(e,
            <PopoverMenu options        = {options}
                         hidePopover    = {() => gd.layout.contextMenu.hide()}/>,
            {
                component: this
            }
        )

    }

    onClick = async () => {

        this.refHint?.current?.hideHint()

        if (!featureAccess(Feature.CHAT)) {
            gd.modals.other.upgrade(Feature.CHAT)
            return
        }

        await openChat(gd.spaces.chats.navigation, this.props.onClickCallback)
    }

    render() {

        const isSelected = gd.layout.navigation.state.currentSection === gd.spaces.chats.navigation

        const icon = isSelected ? "i5-nav-chat-solid" : "i5-nav-chat"

        return (
            <Navigation_BaseButton className            = {this.props.className}
                                   icon                 = {icon}
                                   label                = "Chats"
                                   style                = {this.props.style}
                                   isSelected           = {isSelected}
                                   dndPreview           = {this.props.dndPreview}
                                   dndIsDragged         = {this.props.dndIsDragged}
                                   inMorePopover        = {this.props.inMorePopover}
                                   dndIsDragInProgress  = {this.props.dndIsDragInProgress}
                                   isMouseEntered       = {this.props.isMouseEntered}
                                   onClick              = {this.onClick}
                                   showContextMenu      = {this.showContextMenu}>

                {this.state.newMessagesCount > 0 &&
                    <div className="btn-counter">{this.state.newMessagesCount}</div>
                }

                {gd.spaces.chats.position !== NavigationButtonPosition.MORE &&
                    <Navigation_ButtonHintSpace space={gd.spaces.chats} ref={this.refHint}/>
                }

            </Navigation_BaseButton>
        )
    }
}
